// Some Android WebViews render date inputs as separate editable fields: tapping
// the field does not open the calendar. Open it during the original click gesture.
export function openDatePickerOnClick(event) {
    event.stopPropagation();
    const input = event.currentTarget;
    if (typeof input.showPicker !== 'function') return;
    try {
        input.showPicker();
    } catch {
        // Keep the native default action for browsers that reject showPicker().
    }
}
